import { render } from "./messageDetails.vue?vue&type=template&id=b1180920&scoped=true"
import script from "./messageDetails.vue?vue&type=script&lang=js"
export * from "./messageDetails.vue?vue&type=script&lang=js"

import "./messageDetails.vue?vue&type=style&index=0&id=b1180920&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b1180920"

export default script